import { EmptyState } from '../../components/EmptyState'
import { IconSearch } from '../../components/icons'
import { ButtonLink } from '../../components/links'
import { useDocumentTitle } from '../../components/PageHeader'

/** Any address the app does not know, including an editor link to something since deleted. */
export function NotFoundPage(props: { title?: string; body?: string }) {
  useDocumentTitle('Not found')
  return (
    <EmptyState
      icon={<IconSearch size={48} />}
      title={props.title ?? 'Page not found'}
      body={props.body ?? 'This address does not match a page. It may have moved.'}
      action={
        <ButtonLink to="/dashboard">Go to the dashboard</ButtonLink>
      }
    />
  )
}
